import request from '@/utils/request'

export function getSchoolList({scl_name, province_id, scl_type, scl_nature, scl_nature_type, f211, f985, dual_class, page, gradation, master, doctor, local_batch_type, master_doctor}) {
    return request({
        url: '/web/School/get_school_list',
        method: 'post',
        data: {
            scl_name: scl_name,
            province: province_id,
            scl_type: scl_type,
            scl_nature: scl_nature,
            scl_nature_type: scl_nature_type,
            f211: f211,
            f985: f985,
            dual_class: dual_class,
            page: page,
            gradation: gradation,
            master: master,
            doctor: doctor,
            master_doctor: master_doctor,
            area: localStorage.getItem("area"),
            local_batch_type: local_batch_type
        }
    })
}
export function getArtSchoolList({scl_name, province_id, scl_nature, scl_nature_type, art_type, page}) {
    return request({
        url: '/web/School/getArtSchoolList',
        method: 'post',
        data: {
            scl_name: scl_name,
            province: province_id,
            scl_nature: scl_nature,
            scl_nature_type: scl_nature_type,
            art_type: art_type,
            page: page,
        }
    })
}
export function getHighSchoolList({scl_name, scl_type, scl_nature, scl_nature_type, colleges_level, doublehigh, province, area, page}) {
    return request({
        url: '/web/School/getHighSchoolList',
        method: 'post',
        data: {
            scl_name: scl_name,
            scl_type: scl_type,
            colleges_level: colleges_level,
            doublehigh: doublehigh,
            scl_nature: scl_nature,
            scl_nature_type: scl_nature_type,
            area: area,
            page: page,
            province: province
        }
    })
}
export function getSchoolIntro(scl_id, area) {
    return request({
        url: '/web/school/getSchoolIntro',
        method: 'post',
        data: {
            scl_id: scl_id,
            area: area
        }
    })
}
export function getSchoolSpecial(scl_id) {
    return request({
        url: '/web/school/getSchoolSpecial',
        method: 'post',
        data: {
            scl_id: scl_id,
        }
    })
}
export function getSchoolSpecialDetail(id) {
    return request({
        url: '/web/school/getSchoolSpecialDetail',
        method: 'post',
        data: {
            id: id,
        }
    })
}
export function getSchoolScoreLine(local_type, scl_id, area, page) {
    return request({
        url: '/web/school/getSchoolScoreLine',
        method: 'post',
        data: {
            local_type: local_type,
            scl_id: scl_id,
            area: area,
            page: page
        }
    })
}
export function getSchoolStuPlan(year, local_batch, local_type, scl_id, area, p) {
    return request({
        url: '/web/school/getSchoolStuPlan',
        method: 'post',
        data: {
            year: year,
            local_batch: local_batch,
            local_type: local_type,
            scl_id: scl_id,
            area: area,
            p: p,
        }
    })
}
export function getSchoolSpecialLine(year, local_batch, local_type, scl_id, area, p) {
    return request({
        url: '/web/vip/getSchoolSpecialLine',
        method: 'post',
        data: {
            year: year,
            local_batch: local_batch,
            local_type: local_type,
            scl_id: scl_id,
            area: area,
            p: p,
        }
    })
}
export function getNewsList(page, size, scl_id) {
    return request({
        url: '/web/school/get_news_list',
        method: 'post',
        data: {
            page: page,
            size: size,
            scl_id: scl_id,
        }
    })
}
export function getNewsDetail(id) {
    return request({
        url: '/web/school/get_news_detail',
        method: 'post',
        data: {
            id: id,
        }
    })
}
export function getSchoolView(scl_id) {
    return request({
        url: '/web/school/get_school_view',
        method: 'post',
        data: {
            scl_id: scl_id,
        }
    })
}

export function schoolDiff(scl_id,area) {
    return request({
        url: '/web/school_tools/schoolDiff',
        method: 'post',
        data: {
            scl_id: scl_id,
            area: area
        }
    })
}

export function getSingleSpecial(scl_id) {
    return request({
        url: '/web/School/getSingleSpecial',
        method: 'post',
        data: {
            scl_id: scl_id
        }
    })
}

export function getSingleSpecialDetail(scl_id,scl_special_id) {
    return request({
        url: '/web/School/getSingleSpecialDetail',
        method: 'post',
        data: {
            scl_id: scl_id,
            scl_special_id: scl_special_id
        }
    })
}

export function getSinglePlanSelect(scl_id,area) {
    return request({
        url: '/web/School/getSinglePlanSelect',
        method: 'post',
        data: {
            scl_id: scl_id,
            area: area
        }
    })
}

export function getSinglePlan(scl_id,area,p,year,single,student) {
    return request({
        url: '/web/School/getSinglePlan',
        method: 'post',
        data: {
            scl_id: scl_id,
            area: area,
            p: p,
            year: year,
            single: single,
            student: student,
        }
    })
}

export function getSingleLineSelect(scl_id,area) {
    return request({
        url: '/web/School/getSingleLineSelect',
        method: 'post',
        data: {
            scl_id: scl_id,
            area: area,
        }
    })
}

export function getSingleLine(scl_id,area,p,year,single,student) {
    return request({
        url: '/web/School/getSingleLine',
        method: 'post',
        data: {
            scl_id: scl_id,
            area: area,
            p: p,
            year: year,
            single: single,
            student: student,
        }
    })
}

export function getSingleNews(scl_id,area,p) {
    return request({
        url: '/web/School/getSingleNews',
        method: 'post',
        data: {
            scl_id: scl_id,
            area: area,
            p: p,
        }
    })
}

export function getSingleNewsDetail(id) {
    return request({
        url: '/web/School/getSingleNewsDetail',
        method: 'post',
        data: {
            id: id,
        }
    })
}
export function getSpecialList(scl_id,area,p,year) {
    return request({
        url: '/web/transfer_exam/getSpecialList',
        method: 'post',
        data: {
            scl_id: scl_id,
            area: area,
            page: p,
            limit: 20,
            year: year
        }
    })
}

export function getSpecialNews(scl_id,area,p) {
    return request({
        url: '/web/transfer_exam/getNewsList',
        method: 'post',
        data: {
            scl_id: scl_id,
            area: area,
            page: p,
            limit: 20
        }
    })
}
export function getSpecialNewsDetail(id) {
    return request({
        url: '/web/transfer_exam/getNewsDetail',
        method: 'post',
        data: {
            id: id,
        }
    })
}

export function getPreSpecial(form) {
    return request({
        url: '/web/school/getAdvanceList',
        method: 'post',
        data: form
    })
}

export function getPreBatch(id) {
    return request({
        url: '/web/school/getAdvanceSearch',
        method: 'post',
        data: {
            id: id,
        }
    })
}

export function getSchoolAdvance(form) {
    return request({
        url: '/web/school/getSchoolAdvance',
        method: 'post',
        data: form
    })
}

export function getSearchAdvSchoolList(scl_name) {
    return request({
        url: '/web/school/getAdvanceSchoolList',
        method: 'post',
        data: {
            scl_name: scl_name
        }
    })
}